import React, { useState, useEffect } from "react";
import "../../../styles/legacy/MobileForgotPassword.css";
import { resetPassword } from "shared/api/client/orvalHelpers";

interface MobileResetPasswordProps {
  onClose: () => void;
  setErrorMessage: (message: string) => void;
  setMessageBanner: (message: string) => void;
  resetToken: string;
}

const MobileResetPassword: React.FC<MobileResetPasswordProps> = ({
  onClose,
  setErrorMessage,
  setMessageBanner,
  resetToken,
}) => {
  const [newPassword, setNewPassword] = useState("");
  const [repeatPassword, setRepeatPassword] = useState("");
  const [errors, setErrors] = useState<{ [key: string]: string }>({});

  const validatePassword = (password: string) => {
    const errors: string[] = [];
    if (password.length < 8)
      errors.push("Password must be at least 8 characters.");
    if (!/[A-Z]/.test(password))
      errors.push("Must contain at least one capital letter.");
    if (!/[!@#$%^&*(),.?":{}|<>]/.test(password))
      errors.push("Must contain at least one special character.");
    if (!/[0-9]/.test(password)) {
      errors.push("Password must contain at least one number.");
    }
    return errors;
  };

  useEffect(() => {
    const newErrors: { [key: string]: string } = {};

    if (newPassword) {
      const passwordErrors = validatePassword(newPassword);
      if (passwordErrors.length > 0) {
        newErrors.newPassword = passwordErrors.join(" ");
      }
    }

    if (newPassword && repeatPassword && newPassword !== repeatPassword) {
      newErrors.repeatPassword = "Passwords do not match.";
    }

    setErrors(newErrors);
  }, [newPassword, repeatPassword]);

  const handleSetPassword = async (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    const newErrors: { [key: string]: string } = {};

    const passwordErrors = validatePassword(newPassword);
    if (passwordErrors.length > 0) {
      newErrors.newPassword = passwordErrors.join(" ");
    }

    if (newPassword !== repeatPassword) {
      newErrors.repeatPassword = "Passwords do not match.";
    }

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return;
    }

    try {
      await resetPassword(resetToken, newPassword);
      setMessageBanner("Password reset was successfull.");
      setTimeout(() => {
        setMessageBanner("");
      }, 3000);
      onClose();
    } catch (error) {
      setErrorMessage("An error occurred. Please try again later.");
      setTimeout(() => {
        setErrorMessage("");
      }, 3000);
      onClose();
    }
  };

  return (
    <div className="mobile-forgot-password-modal">
      <img className="logo" src="/images/poetics-stream-lockup.svg" alt="Poetics Stream logo" />
      <div className="top-message-mobile">
        <div className="title-login-mobile">Set new password</div>
      </div>
      <div className="email-container-reset-mobile">
        <span className="reset-email-label">New password*</span>
        <input
          type="password"
          placeholder="Enter new password"
          className="reset-input-field-mobile"
          value={newPassword}
          onChange={(e) => setNewPassword(e.target.value)}
        />
        {errors.newPassword && (
          <div className="change-password-error">{errors.newPassword}</div>
        )}
      </div>
      <div className="email-container-reset-mobile">
        <span className="reset-email-label">Repeat password*</span>
        <input
          type="password"
          placeholder="Repeat new password"
          className="reset-input-field-mobile"
          value={repeatPassword}
          onChange={(e) => setRepeatPassword(e.target.value)}
        />
        {errors.repeatPassword && (
          <div className="change-password-error-mobile">
            {errors.repeatPassword}
          </div>
        )}
      </div>

      <div className="button-container-reset-mobile">
        <button
          className="buttons-reset-mobile"
          id="cancel-btn-reset-mobile"
          onClick={onClose}
        >
          Cancel
        </button>
        <button
          className="buttons-reset-mobile"
          id="reset-btn-reset-mobile"
          onClick={handleSetPassword}
        >
          Set password
        </button>
      </div>
    </div>
  );
};

export default MobileResetPassword;
